document.addEventListener('DOMContentLoaded', function () {
    console.log('newsletter-form.js loaded');

    const form = document.getElementById('newsletterForm');

    if (!form) {
        return;
    }
    //display error/feedback
    if ($('.validation-summary-errors').length || $('.newsletter-success-message').length || $('.newsletter-message').length) {
        var $summary;
        if ($('.validation-summary-errors').length) {
            $summary = $('.validation-summary-errors')
        }
        else if ($('.newsletter-success-message').length) {
            $summary = $('.newsletter-success-message');
        }
        else {
            $summary = $('.newsletter-message');
        }
        $('html, body').stop(true, false).animate({
            scrollTop: $summary.offset().top
        }, 1000);
    }


    const email = document.getElementById('Email');
    const postcode = document.getElementById('Postcode');
    const preferences = document.getElementById('Preferences');
    const counter = document.getElementById('preferencesCount');
    const submitButton = document.getElementById('newsletterSubmitButton');

    $('#Email').on('blur', function () {
        if (validateEmail()) $('.valid-tick').removeClass('hide');
    });

    $('#Postcode').on('blur', function () {
        if (validatePostcode()) $('.valid-tick').removeClass('hide');
    });

    $('#Preferences').on('blur', function () {
        if (validatePreferences()) $('.valid-tick').removeClass('hide');
    });

    if (postcode) {
        postcode.addEventListener('input', function () {
            this.value = this.value.replace(/\D/g, '').substring(0, 4);
        });
    }

    if (preferences) {

        const updateCounter = function () {
            if (counter) {
                counter.textContent = preferences.value.length;
            }
        };

        updateCounter();

        preferences.addEventListener('input', function () {

            if (this.value.length > 255) {
                this.value = this.value.substring(0, 255);
            }

            updateCounter();
        });
    }

    function validateEmail() {

        const validation = document.querySelector('[data-valmsg-for="Email"]');

        validation.textContent = '';
        email.classList.remove('error');
        $('#Email').next('span').addClass('hide');

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!email.value.trim()) {
            validation.textContent = 'Email address is required';
            email.classList.add('error');
            $('#Email').next('span').removeClass('hide');
            $('#Email').attr('tabindex', '-1').focus();
            return false;
        }
        else if (!emailRegex.test(email.value.trim())) {
            validation.textContent = 'Please enter a valid email address';
            email.classList.add('error');
            $('#Email').next('span').removeClass('hide')
            $('#Email').attr('tabindex', '-1').focus();
            return false;
        }
        else {
            $('#Email').prev('label span').removeClass('hide');
        }

        return true;
    }

    function validatePostcode() {

        const validation = document.querySelector('[data-valmsg-for="Postcode"]');

        validation.textContent = '';
        postcode.classList.remove('error');
        $('#Postcode').next('span').addClass('hide');

        if (postcode.value && !/^\d{4}$/.test(postcode.value)) {
            validation.textContent = 'Postcode must be exactly 4 digits';

            postcode.classList.add('error');
            $('#Postcode').next('span').removeClass('hide').attr('tabindex', '-1').focus();;

            return false;
        }

        return true;
    }

    function validatePreferences() {

        const validation = document.querySelector('[data-valmsg-for="Preferences"]');

        validation.textContent = '';
        preferences.classList.remove('error');
        $('#Preferences').next('span').addClass('hide');

        if (preferences.value.length > 255) {

            validation.textContent = 'Maximum length is 255 characters';

            preferences.classList.add('error');
            $('#Preferences').next('span').removeClass('hide').attr('tabindex', '-1').focus();;
            return false;
        }

        return true;
    }

    form.addEventListener('submit', function (e) {

        const emailValid = validateEmail();
        const postcodeValid = validatePostcode();
        const preferencesValid = validatePreferences();

        
        if (!emailValid ||
            !postcodeValid ||
            !preferencesValid) {
            if (!postcodeValid) $('#Postcode').next('span').removeClass('hide');
            if (!preferencesValid) $('#Preferences').next('span').removeClass('hide');
            e.preventDefault();
        }
        else {
            submitButton.disabled = true;
            submitButton.textContent = "Submitting...";
            return true;
        }
    });
});